import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../Common/Button';

const AlreadyExistsStep = ({ onResetPassword, onCancel, userRequest }) => {

    return (
        <div className="already-exist-step">
            <p>This username ({ userRequest.userName}) is already in use. Do you need to reset your password?</p>
            <div className="mb-2"><Button type="button" onClick={onCancel} text="Back" bootstrapClass="outline-light" /></div>
            <div><Button type="submit" onClick={onResetPassword} bootstrapClass="outline-light" text="Reset Password" /></div>

            <div className="mt-4">
                <strong>Need help?</strong>
                <div><a href="https://ehsolution.zendesk.com/hc/en-us/articles/4401787962267" target="blank">My account is inactive; how do I reactivate it?</a></div>
                <div><a href="https://ehsolution.zendesk.com/hc/en-us/articles/360015248294-How-do-I-get-access-to-more-locations-" target="blank">I need to access a second location; do I need to sign up again?</a></div>
                <div><a href="https://ehsolution.zendesk.com/hc/en-us/articles/4401778016155" target="blank">How do I get access to another company&apos;s subscription?</a></div>
                <div><a href="https://ehsolution.zendesk.com/hc/en-us" target="blank" className="me-2">Let me search for a question</a> | <a href="https://ehsolution.zendesk.com/hc/en-us" target="blank" className="ms-2">See all support articles</a></div>
            </div>
        </div>
    );
};

AlreadyExistsStep.propTypes = {
    userRequest: PropTypes.object.isRequired,
    onResetPassword: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};

export default AlreadyExistsStep;
